// extracted by mini-css-extract-plugin
export default {"avatar":"avatar_avatar__yCQbX","avatarButton":"avatar_avatarButton__i0WPL"};